<script lang="ts">
	import { generateSources} from "$lib/utils/images-utils";
	import classNames from "classnames";
	import { onMount, tick } from "svelte";

  export let image;

  let isVisible = false; // Initially hide the image

  let sources: { type: string; media?: string; srcset: string }[] | null = null
  console.log('image', image.details)
  sources = generateSources(image.url, image.details.image.width, image.details.image.height);

  let imgEl: HTMLImageElement;

  const handleOnError = async () => {
    if (imgEl instanceof HTMLImageElement) {
      imgEl.onerror = null; // Prevent infinite loop
      await tick();
      Array.from(imgEl.parentNode.children).forEach(element => {
        if ((<HTMLImageElement>element).srcset != image.url) {
        (<HTMLImageElement>element).srcset = image.url;
        }
      })
      // change the src only if different from current
      if (image.url != imgEl.src) {
        imgEl.src = image.url;
      }
      isVisible = true;
    }
  }

  const handleOnLoad = () => {
    isVisible = true;
  };

  onMount(async () => {
    if (imgEl.complete && imgEl.naturalWidth === 0) {
      await handleOnError();
    } else if (imgEl.complete) {
      handleOnLoad();
    }
  });
</script>

{#if sources && sources.length > 0}
  <picture class={classNames($$restProps.class, { 'hidden': !isVisible })}>
    {#each sources as source}
      <source type={source.type} media={source.media} srcset={source.srcset} />
    {/each}
    <img
      bind:this={imgEl}
      class={$$restProps.class}
      src={image.url}
      alt={$$restProps.alt}
      on:load={handleOnLoad}
      on:error={handleOnError}
    />
  </picture>
{/if}